import authTypes from './auth.authTypes';
import axios from 'axios';
import storage from '../../helpers/storage';

let url;
if (process.env.VUE_APP_NODE_ENV == 'production') {
  url = `${process.env.VUE_APP_API_LIVE_URI}/admin`;
} else {
  url = `${process.env.VUE_APP_API_TEST_URI}/admin`;
}

export default {
  login({ commit }, data) {
    commit(authTypes.LOGIN_REQUEST);
    axios
      .post(`${url}/login`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => {
        const  manager  = res.data.admin;
        if(manager.isAdmin === false){
          commit(authTypes.LOGIN_BLOCK, "Not_allowed");
          
        }else{
          storage.set('manager', manager);
          commit(authTypes.LOGIN_SUCCESS, manager);
        }
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(authTypes.LOGIN_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(authTypes.LOGIN_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(authTypes.LOGIN_FAILED, { error });
      });
  },
  signup({ commit }, obj) {
    commit(authTypes.SIGNUP_REQUEST);
    axios
      .post(`${url}/signup`, obj, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => {
        const { manager } = res.data;
        storage.set('manager', manager);
        commit(authTypes.SIGNUP_SUCCESS, manager);
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(authTypes.SIGNUP_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(authTypes.SIGNUP_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(authTypes.SIGNUP_FAILED, { error });
      });
  },
  forgotPassword({ commit }) {}
};
